import { SET_LOADED, SET_LOADING, SET_PAGE_INFO } from './types';

export const send = (settings) => dispatch => {
  dispatch({
    type: SET_PAGE_INFO,
    payload: settings
  });
};

export const loading = (is) => dispatch => {
  dispatch({
    type: is ? SET_LOADING : SET_LOADED
  });
}